// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".rights-statement-button[data-v-4daef65b]{color:#4d4d4d;background:#f1f1ee;border-radius:.25rem;padding:.38rem .625rem;font-size:.875rem;transition:.3s ease-in-out;overflow:hidden}.rights-statement-button[data-v-4daef65b]:hover{cursor:pointer;box-shadow:2px 2px 4px 0 rgba(0,0,0,.1)}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
